<template>
  <q-dialog v-model="helpTourDialog" transition-show="fade" transition-hide="fade">
    <div class="initialBackDrop" style="min-height: 100vh">
      <div class="q-pa-md q-gutter-sm" style="width: 80ex; margin-left: auto; margin-right: auto; margin-top: 5%; margin-bottom: auto; border-radius: 10px;">
        <q-card style="border-radius: 10px;" class="q-pa-md">
          <q-card-section>
            <q-card-actions align="right" class="text-primary">
              <q-btn icon="close" flat round dense v-close-popup align="right" class="circle-btn" style="margin-bottom: 5px" />
            </q-card-actions>

            <h4 class="helpHeader">Welcome to FacDocs v{{versionNumber}}!</h4>

            <h6 style="text-align: center; font-weight: 600; margin-bottom: 20px; margin-top: 30px">
              FacDocs is the Hawaii Department of Education Office of Facilities
              and Operation’s application that enables authorized users to
              discover and retrieve archived construction artifacts. At the
              current version, users can discover "historical" jobs imported
              from FacTrak and as-built drawings migrated from the DOE’s
              Dropbox.
            </h6>

            <q-card-actions align="center">
              <div class="q-gutter-md" style="display: flex; flex-direction: column">
                <q-btn unelevated no-caps text-color="white" class="helpDialogButton" label="Change Password" @click="displayChangePassword" v-close-popup v-if="useLoginPage" />
                <q-btn unelevated no-caps text-color="white" class="helpDialogButton" label="Feedback / Request Access" @click="displayFeedbackForm" v-close-popup />
                <div style="font-size: 16px; font-weight: bold;">Contact Us: <a href="mailto:FacDocsAdmin@eworldes.com">FacDocsAdmin@eworldes.com</a></div>
                <div align="center">
                  <q-btn flat color="primary" style="font-size: 16px; font-weight: bold;" label="User Guide" no-caps type="a" href="./FacDocs User Guide.pdf" target="_blank" />
                  <q-btn v-if="userUploadAccessLevel" flat color="primary" style="font-size: 16px; font-weight: bold;" label="Upload Guide" no-caps type="a" href="./FacDocs Upload Guide.pdf" target="_blank" />
                  <q-btn v-if="userEditAccessLevel" flat color="primary" style="font-size: 16px; font-weight: bold;" label="Edit Guide" no-caps type="a" href="./FacDocs Edit Guide.pdf" target="_blank" />
                  <q-btn v-if="userAdminAccessLevel" flat color="primary" style="font-size: 16px; font-weight: bold;" label="Admin Guide" no-caps type="a" href="./FacDocs Admin Guide.pdf" target="_blank" />
                </div>
              </div>
            </q-card-actions>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-dialog>
</template>

<script>
import { ref } from 'vue'

export default ({
  props: {
    userAdminAccessLevel: Boolean,
    userEditAccessLevel: Boolean,
    userUploadAccessLevel: Boolean,
    feedbackForm: Object,
    changePassword: Object
  },
  setup(props) {
    const useLoginPage = process.env.VUE_APP_USE_LOGIN_PAGE === "true";
    const versionNumber = process.env.VUE_APP_VERSION_NUMBER;
    const helpTourDialog = ref(false);

    function displayHelpTourDialog() {
      helpTourDialog.value = true;
    }

    function displayFeedbackForm() {
      props.feedbackForm.displayFeedbackForm();
    }

    function displayChangePassword() {
      props.changePassword.displayChangePassword();
    }

    return {
      //variables
      useLoginPage,
      versionNumber,
      helpTourDialog,

      //functions
      displayHelpTourDialog,
      displayFeedbackForm,
      displayChangePassword
    }
  }
})
</script>

